import styles from "./ListItems.module.css";
import ListItem, { ListItemType } from "./ListItem";

interface ListItemsProps {
  items?: ListItemType[];
}

const ListItems = ({ items }: ListItemsProps) => {
  if (!items) {
    return (
      <div className={styles.container}>
        <ListItem />
        <ListItem />
        <ListItem />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {items.map((item) => (
        <ListItem key={item.text} item={item} />
      ))}
    </div>
  );
};

export default ListItems;
